export default __webpack_public_path__ + "static/media/JUSTACOTE.e98fb89a.png";